import {
  TOGGLE_SIDEBAR,
  OPEN_MENU_KEY_EQUAL_ROUTE,
  SET_MENU_ITEM,
  UPDATE_WINDOW_WIDTH
} from "@/store/mutation-types";

export default {
  [UPDATE_WINDOW_WIDTH]: ({ commit }, width) => {
    commit(UPDATE_WINDOW_WIDTH, width);
  },
  [TOGGLE_SIDEBAR]: ({ commit }, value) => {
    commit(TOGGLE_SIDEBAR, value);
  },
  [SET_MENU_ITEM]: ({ commit }, menuList) => {
    commit(SET_MENU_ITEM, menuList);
  },
  [OPEN_MENU_KEY_EQUAL_ROUTE]: ({ commit }, key) => {
    commit(OPEN_MENU_KEY_EQUAL_ROUTE, key);
  }
};
